module.exports = __webpack_public_path__ + "img/caconde.756fdc60.png";